<!-- « Signaler une réponse » (P5.1.2) : une feuille du bas, titrée comme la
     ligne du menu qui l'ouvre. Le motif, une précision facultative, « Envoyer ». -->
<vw-toast-popup [isOpen]="isOpen" [title]="'willy.menu.report' | translate"
  [subtitle]="'common.modals.report.subtitle' | translate" (close)="close()">
  <form class="flex flex-col gap-5 px-4 pb-6" novalidate (ngSubmit)="onSendButtonClick()">
    <div class="flex flex-col gap-2">
      <p id="report-question" class="text-body-s font-semibold text-vw-body">{{ 'common.modals.report.question' | translate }}</p>
      <vw-choice-selector variant="list" data-testid="report-choices" [options]="choiceOptions"
        [value]="selectedChoice" (valueChange)="onChoiceSelected($event)"
        [ariaLabel]="'common.modals.report.question' | translate"></vw-choice-selector>
      @if (choiceError) {
        <p role="alert" class="text-body-s text-vw-danger" data-testid="report-choice-error">
          {{ 'common.modals.report.choice-required' | translate }}
        </p>
      }
    </div>

    <div class="flex flex-col gap-2">
      <label for="report-message" class="text-body-s font-semibold text-vw-body">
        {{ 'common.modals.report.message.label' | translate }}
      </label>
      <textarea id="report-message" name="message" rows="3" data-testid="report-message"
        [maxlength]="messageMaxLength" [(ngModel)]="message"
        [placeholder]="'common.modals.report.message.placeholder' | translate"
        class="w-full resize-none rounded-field border border-vw-line-strong bg-vw-surface p-3 text-body text-vw-ink outline-none placeholder:text-vw-muted focus:ring-2 focus:ring-vw-primary"></textarea>
    </div>

    <div class="flex flex-col gap-3">
      @if (sendFailed) {
        <p role="alert" class="text-body-s text-vw-danger" data-testid="report-error">
          {{ 'errors.businessException' | translate }}
        </p>
      }
      <!-- 48 px, pleine largeur ; jamais grisé : sans motif, il dit ce qui manque. -->
      <vw-button type="submit" look="primary" customClass="w-full" data-testid="report-send"
        [label]="'common.send' | translate" [loading]="sending"></vw-button>
    </div>
  </form>
</vw-toast-popup>
